export const NAMESPACE = "@seriously-rad/seriouslyrad-framework-core/";